import * as React from 'react';

interface Props {
  handleSubmit: (search: string) => void;
  isSearching: boolean;
}

interface State {
  search: string;
}

export default class Search extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
    };
  }

  render() {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          this.props.handleSubmit(this.state.search);
        }}
      >
        <div
          className={`control ${this.props.isSearching ? 'is-loading' : ''}`}
        >
          <input
            type="text"
            className="input"
            disabled={this.props.isSearching}
            name="search"
            value={this.state.search}
            onChange={(e: any) => this.setState({ search: e.target.value })}
            placeholder="Search for anything musical..."
          />
        </div>
      </form>
    );
  }
}
